import { ApiClient } from '../../../../infra';
import { collaboratorPageFromBackend } from '../../../../domain';
/**
 * O que o conceito "colaboradores" pergunta ao servidor.
 *
 * Mora aqui e nao num servico geral: era metade de um `PatientApi` que juntava
 * este endpoint com o de Monitoramentos so porque os dois devolvem paciente. Sao
 * assuntos diferentes, com papeis diferentes e caminhos diferentes - o que tinham
 * em comum era a forma da resposta, e forma nao e dono.
 *
 * O Relatorio de Sono chama daqui E de `monitoring.api.ts`, conforme o papel de
 * quem monta a selecao. Um conceito consumir outros dois e o esperado.
 */
export class CollaboratorsApi {
    constructor() {
        this.client = ApiClient.INSTANCE;
    }
    static { this.INSTANCE = new CollaboratorsApi(); }
    /**
     * A lista de colaboradores com a ultima medicao de cada um.
     *
     * Sao DOIS endpoints, escolhidos pelo papel de quem pergunta: o super admin ve
     * a base toda, o admin de empresa ve a propria empresa. Quem decide e o
     * presenter, que e quem sabe do papel; aqui so se recebe a decisao.
     *
     * O `size` de um milhao e herdado do painel antigo, e NAO e descuido: a
     * ordenacao das 14 colunas e feita no cliente, e o backend nao aceita criterio
     * de ordenacao - ordenar corretamente exige ter tudo em maos. Com 113 pacientes
     * em QA nao incomoda; com dezenas de milhares incomodaria, e ai a saida e o
     * backend passar a ordenar. Vale como aviso, nao como conserto desta reescrita.
     */
    async fetchCollaborators(criteria, scope, signal) {
        const measurementTypeStatuses = [];
        if (criteria.measurementTypeId) {
            const levels = [];
            if (criteria.measurementStatusLevel) {
                levels.push(criteria.measurementStatusLevel);
                // O painel antigo faz o mesmo: pedir "Critico" traz tambem o que nao
                // tem faixa configurada. Ver a nota sobre UNKNOWN no dominio.
                if (criteria.measurementStatusLevel === 'CRITICAL') {
                    levels.push('UNKNOWN');
                }
            }
            measurementTypeStatuses.push({
                measurementTypeId: criteria.measurementTypeId,
                measurementStatusLevels: levels
            });
        }
        // A ausencia e os dois modos que a pedem - ver o bloco das datas, abaixo.
        const ausente = criteria.activityPresence !== undefined;
        const payload = {
            page: { number: 0, size: 1000000 },
            searchParameters: {
                name: criteria.name ?? null,
                cpf: criteria.cpf ?? null,
                email: criteria.email ?? null,
                companyId: criteria.companyId ?? null,
                hasCompany: null,
                measurementTypeStatuses,
                /*
                 * Os periodos que os cartoes de Adocao e Engajamento mandam.
                 *
                 * ATENCAO aos nomes: o servidor espera `activeFrom`/`activeTo`,
                 * `inactiveFrom`/`inactiveTo` e `registeredFrom`/`registeredTo`
                 * (`SuperAdminPatientSearchRequest` e `CompanyEmployeeSearchRequest`). O
                 * Jackson descarta em silencio o que nao reconhece - um nome trocado aqui
                 * nao falha, so deixa de filtrar.
                 *
                 * O par de datas vira PRESENCA ou AUSENCIA, conforme o modo.
                 *
                 * Um par so no endereco, dois no servidor: `activeFrom`/`activeTo` quer
                 * dizer "registrou entre", e `inactiveFrom`/`inactiveTo` quer dizer "nao
                 * registrou entre". `STALLED` manda os DOIS - nada no intervalo, e alguma
                 * coisa em algum momento ate o fim -, que e o que separa "parou" de "nunca
                 * comecou".
                 *
                 * `activityKind` so acompanha a presenca: "nao treinou" e outra pergunta, e
                 * quem so mede apareceria como parado. Ver `PatientSpecification.inactiveBetween`.
                 */
                activeFrom: ausente ? null : (criteria.activeFrom ?? null),
                activeTo: ausente && criteria.activityPresence !== 'STALLED' ? null : (criteria.activeTo ?? null),
                inactiveFrom: ausente ? (criteria.activeFrom ?? null) : null,
                inactiveTo: ausente ? (criteria.activeTo ?? null) : null,
                activityKind: ausente ? null : (criteria.activityKind ?? null),
                registeredFrom: criteria.registeredFrom ?? null,
                registeredTo: criteria.registeredTo ?? null,
                // O periodo do filtro de faixa - a barra do Indice de saude geral o manda.
                statusFrom: criteria.statusFrom ?? null,
                statusTo: criteria.statusTo ?? null,
                activeAccountsOnly: criteria.activeAccountsOnly ?? null,
                anamnese: criteria.anamnese ?? null
            }
        };
        const path = scope === 'all' ? '/patient/all_patients_with_last_measurement' : '/patient/admin/company-employees';
        try {
            return collaboratorPageFromBackend((await this.client.send('POST', path, payload, signal)));
        }
        catch (caught) {
            // 404 e "nenhum colaborador casa o filtro", nao falha.
            if (caught instanceof Error && caught.message.startsWith('404')) {
                return { elements: [] };
            }
            throw caught;
        }
    }
}
//# sourceMappingURL=collaborators.api.js.map